<template>
  <div>
    <HeartysanCategoryHead
        v-if="categoryLoaded"
        :navTabs="navTabs"
        :showFilter="showFilter"
        :active="active"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @changeTab="(data) => $emit('changeTab', data)"
        @filter="$emit('filter')"
        @reload="$emit('reload')"
        @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <HeartysanCategoryFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <HeartysanCategoryTable
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import HeartysanCategoryHead from "./HeartysanCategoryHead/HeartysanCategoryHead";
  import HeartysanCategoryTable from "./HeartysanCategoryTable/HeartysanCategoryTable";
  import HeartysanCategoryFilter from "./HeartysanCategoryFilter/HeartysanCategoryFilter";

  export default {
    name: "HeartysanCategoryTableBlock",

    components: {
      HeartysanCategoryHead,
      HeartysanCategoryTable,
      HeartysanCategoryFilter,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
      navTabs: Object,
      categoryLoaded: Boolean,
      active: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>


